<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
          <h2>🎉 KYC - Know your Client? ...or is it Know your Cat 🎉</h2>
  
          <p>🌟 "Welcome to the cozy corner of RiskyPaws where KYC doesn’t just mean 'Know Your Customer'; here it’s 'Know Your Cat'! 🐾🔍</p>
  
    
       <p>Just like understanding a cat’s quirky habits is key to a happy coexistence, grasping the nuances of your financial personality is crucial for a prosperous investment journey. Each of us has a unique 'catitude' towards risk - some of us are bold lions ready to pounce on high-risk opportunities, while others are like cautious housecats, preferring the safe and cozy nook of low-risk investments. Think Ginger cats vs tabby cats...we don't know why but ginger cats just love to get themselves into riskier situations.  We don't make the rules...actually we do but you know what we mean!🦁🏡</p>

       <p>Time horizon in finance? Think of it as a cat’s nine lives. Some goals are short-lived – a quick sprint to catch the laser dot, while others are a long, leisurely bask in the sun. Whether you’re saving for a vacation next year or your retirement decades away, each goal has its own timeline. ⏳☀️

And what about investment knowledge? Well, it’s like a cat’s curiosity - always on the prowl for more. Whether you’re a kitten just learning the ways of the financial world or a wise old feline with years of experience, understanding your level of knowledge helps tailor your investment journey. 🐱📚</p>

<p>Remember, not all your accounts need to purr the same tune. Your retirement account might be like an old cat napping in the sun - steady and secure, while you might allocate a 'play money' account for those wild catnip moments, where you can afford to be a bit more adventurous (or should we say, ‘degenerate’) like the WallStreetBets crowd. And by the way, we love the YOLO crowd because they brought back an enthusiasm for retail investing that hasn't been seen ever.  Everyone should have an opportunity to make money in the markets but the old adage must always apply that with greater returns come greater risk. 🎲🐾</p>

<p>In RiskyPaws, we believe each of your financial lives deserves its own strategy. So, let's curl up and unravel the mysteries of your financial personality with KYC - it’s all about making your investment journey as unique and delightful as a cat chasing its favorite feather toy!" 🪶😺</p>

        </div>

         
</div>
</div><br><br><br><br><br><br>
</template>


<script>
</script>



<style scoped>
.wrapper {
display: flex;
flex-direction: column;
align-items: center;
}

.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}

.stylish-links {
background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
color: #333;
font-size: 1.4em;
margin-bottom: 15px;
}

.stylish-links ul {
list-style: none;
padding: 0;
}

.stylish-links ul li {
background-color: #fff;
margin: 10px 0;
padding: 10px;
border-radius: 8px;
box-shadow: 0 2px 4px rgba(0,0,0,0.1);
transition: all 0.3s ease;
}

.stylish-links ul li a {
color: black;
text-decoration: none;
font-weight: bold;
}

.stylish-links ul li:hover {
background-color: #4A148C;
}

.stylish-links ul li:hover a {
color: #fff;
}
</style>